"use client";

import { Label } from "@/components/shadcn/label";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/shadcn/select";
import { useRouter } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";

type NewsArticlesSortProps = {
    selectedSortBy: string | null | undefined;
    selectedSortOrder: string | null | undefined;
};
export default function NewsArticlesSort({
    selectedSortBy,
    selectedSortOrder,
}: NewsArticlesSortProps) {
    const t = useTranslations("news");
    const router = useRouter();
    const searchParams = useSearchParams();
    const selectedValue =
        selectedSortBy && selectedSortOrder
            ? `${selectedSortBy}-${selectedSortOrder}`
            : "";

    const sortOptions = [
        { label: t("sortNewest"), value: "NaviDate-desc" },
        { label: t("sortOldest"), value: "NaviDate-asc" },
    ];

    const handleOnChange = (value: string) => {
        const [sortKey, sortOrder] = value.split("-");
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set("sortBy", sortKey);
        newSearchParams.set("sortOrder", sortOrder);
        return router.push(
            `/haberler/tum-haberler?${newSearchParams.toString()}`,
        );
    };

    return (
        <div className="flex flex-col gap-1 pb-2">
            <Label htmlFor="news-articles-sort">{t("sortPlaceholder")}</Label>
            <Select onValueChange={handleOnChange} value={selectedValue}>
                <SelectTrigger id="news-articles-sort" className="w-[180px]">
                    <SelectValue placeholder={t("sortPlaceholder")} />
                </SelectTrigger>
                <SelectContent>
                    {sortOptions?.map((item) => (
                        <SelectItem
                            key={`AllNewsArticlesSortOptions-${item.value}`}
                            value={item.value}
                        >
                            {item.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
